import React, { ComponentProps, PropsWithChildren } from "react";

import "./GhostButton.scss";

function GhostButton({
  children,
  className = "",
  ...restProps
}: PropsWithChildren<ComponentProps<"button">>) {
  return (
    <button className={`custom-ghost-btn ${className}`} {...restProps}>
      {children}
    </button>
  );
}

export default GhostButton;
